export const mockAccountStatsData = {
    analysis_hours_current: 1500,
    analysis_hours_max: 10000,
    storage_current: 2000,
    storage_max: 10000
};

// Used In: DemoRectangle.tsx
export const tempCurrentUserDemoFeaturesList = [
    'View the platform to familiarize yourself with its functionality',
    'Work with preloaded, analyzed RNA-Seq and ChIP-seq data sets',
    'The ability to make changes to graphs and see the effects in real time'
];

export function findDemoAnalysesOfDemoExperiment(demoExperimentId: string) {
    return demoAnalyses.filter(analyis => analyis.experiment_id === demoExperimentId);
}

export function findDemoExperimentFromExperimentId(demoExperimentId: string) {
    return demoExperiments.find(exp => exp.id === demoExperimentId);
}

export function isDemoExperiment(id: string) {
    return demoExperiments.some(exp => exp.id === id);
}

export const demoExperiments = [
    // Chip seq demo
    // since this is mock, a lot of these fields are not needed
    {
        id: '0000c419-b1ad-4daa-bead-daa4ac419000',
        created_time: '2025-12-11T16:34:00.000Z',
        ex_time: '2025-12-11T16:34:00.000Z',
        name: 'ChIP-seq Demo: CC vs CAF Occupancy',
        description:
            'This tutorial uses a subset of samples from the public GEO dataset GSE157927, which profiled H3K27ac chromatin occupancy in pancreatic cancer models using ChIP-seq. The subset includes 16 untreated human cell lines comprising 9 pancreatic cancer (CC) cell lines and 7 cancer-associated fibroblast (CAF) cell lines, with each sample representing a distinct cell line. The dataset is designed for occupancy analysis to identify and compare H3K27ac-enriched genomic regions between the two cellular populations, illustrating a typical ChIP-seq workflow including quality control, alignment, peak calling, occupancy analysis, differential binding analysis, and downstream functional interpretation.',
        organism: 'Homo sapiens',
        sequencing_type: 'ChIP Seq',
        sequencing_platform: 'Illumina',
        platform_model: 'Illumina HiSeq 2500',
        sequencing_read_type: 'singled',
        experiment_num: '63',
        analysis_count: '4',
        sample_count: '32'
    },
    // RNA
    {
        id: '4015c7cc-1982-4bd4-ae1c-140a7aa6fba9',
        created_time: '2023-10-05T19:21:55.555Z',
        created_by: '440f10bf-0bc4-4492-af23-2453d750a12a',
        ex_id: '4e16d2bb-573e-44c8-b0e8-d75cc2c2b29e',
        ex_time: '2023-10-05T19:21:55.555Z',
        ex_user: '440f10bf-0bc4-4492-af23-2453d750a12a',
        ex: {
            key: 'value1'
        },
        name: 'Transcriptomic Changes in Dilated Cardiomyopathy',
        description:
            'Transcriptomic analysis of human heart failure reveals dysregulated gene profiles in dilated cardiomyopathy.\n The data in this demo dataset is obtained from the work of Sweet ME, et al 2018 (data accessible at NCBI GEO database, accession GSE116250).',
        organism: 'Homo sapiens',
        sequencing_type: 'RNA Seq',
        analyzed_molecule: 'mRNA',
        rna_selection_method: 'polyA Selection',
        sequencing_adapter: 'Illumina TruSeq Adapters',
        sequencing_platform: 'Illumina',
        platform_model: 'Illumina HiSeq 1500',
        sequencing_read_type: 'singled',
        sequencing_sense: 'Unstranded',
        archived: false,
        pending: false,
        group_options: {},
        experiment_num: '62',
        analysis_count: '1',
        sample_count: '6'
    }
];

export const demoAnalyses = [
    // ChIP Motif
    {
        experiment_num: '63',
        analysis_num: '114',
        id: '3693d9c5-5d4d-4bcc-9da4-2b11190c41c4',
        created_time: '2025-12-11T16:34:00.000Z',
        ex_time: '2025-12-11T16:34:00.000Z',
        name: 'ChIP-seq Demo: CC vs CAF Occupancy - Motif',
        description: 'This analysis performs a motif analysis based on results from the initial differential binding analysis.',
        status: 'completed',
        experiment_id: '0000c419-b1ad-4daa-bead-daa4ac419000',
        analysis_type: 'ChIP Motif'
    },
    // ChIP DBA
    {
        experiment_num: '63',
        analysis_num: '113',
        id: '54e1f49b-2210-4785-9efa-54f343d8e001',
        created_time: '2025-12-11T16:34:00.000Z',
        ex_time: '2025-12-11T16:34:00.000Z',
        name: 'ChIP-seq Demo: CC vs CAF Occupancy - DBA',
        description: 'This analysis performs a differential binding analysis based on results from the initial ChIP Seq analysis.',
        status: 'completed',
        experiment_id: '0000c419-b1ad-4daa-bead-daa4ac419000',
        analysis_type: 'Differential Binding'
    },
    // Chip GO
    {
        experiment_num: '63',
        analysis_num: '112',
        id: '1e28f024-6140-4b25-9c9a-fb187495eb6c',
        created_time: '2025-12-11T16:34:00.000Z',
        ex_time: '2025-12-11T16:34:00.000Z',
        name: 'ChIP-seq Demo: CC vs CAF Occupancy - GO',
        description:
            'This analysis performs a Gene Ontology (GO) functional enrichment analysis based on results from the initial ChIP Seq analysis.',
        status: 'completed',
        experiment_id: '0000c419-b1ad-4daa-bead-daa4ac419000',
        analysis_type: 'Functional Enrichment'
    },
    // Chip Default
    {
        experiment_num: '63',
        analysis_num: '111',
        id: 'c419defa-014c-4da4-bead-b1ad1a900000',
        created_time: '2025-12-11T16:34:00.000Z',
        ex_time: '2025-12-11T16:34:00.000Z',
        name: 'Default ChIP Analysis',
        description:
            'This analysis trims and aligns the FastQ files. It then performs quality control, peak calling, peak annotation, profiling, and reproducibility analysis',
        status: 'completed',
        experiment_id: '0000c419-b1ad-4daa-bead-daa4ac419000',
        analysis_type: 'ChIP Seq Default'
    },
    // RNA
    {
        experiment_num: '62',
        analysis_num: '110',
        id: 'a0b1c2d3-e4f5-6789-0a1b-2c3d4e5f6789',
        created_time: '2023-09-18T21:48:11.363Z',
        created_by: '440f10bf-0bc4-4492-af23-2453d750a12a',
        ex_id: 'b29e2216-8efe-4250-b801-36a3ce28ccde',
        ex_time: '2023-09-18T21:48:11.363Z',
        ex_user: '440f10bf-0bc4-4492-af23-2453d750a12a',
        ex: {},
        name: 'Transcriptomic Changes in Dilated Cardiomyopathy',
        description: '',
        pipeline_id: 'c61b57bf-0ccd-4e2d-a0e5-dd560fc29672',
        organism: 'Homo sapiens',
        group_options: {
            Individual: ['Tibetan-3', 'Han-1', 'Tibet-5', 'Tibetan-4', 'Han-4', 'Han-5', 'Tibetan-2', 'Han-3', 'Tibetan-1', 'Han-2'],
            collection_age_days: ['0.25', '5', '0', '3', '1'],
            collection_age_name: ['6h', '5d', '0h', '3d', '1d'],
            condition: ['hypoxia', 'normoxia'],
            country_of_origin: ['Tibet', 'China']
        },
        status: 'completed',
        archived: false,
        experiment_id: '4015c7cc-1982-4bd4-ae1c-140a7aa6fba9',
        samples: [
            '0029efef-a143-45ae-a00a-276ab38dcc04',
            '053eb921-cf06-40e6-8307-d6f50b53f95f',
            '082cb0df-8696-4985-aff3-a96443073093',
            '09863467-5fa9-4e4c-91d7-4d2bff60d513'
        ],
        analysis_type: 'RNA Seq'
    }
];

// Manage samples is no longer accessable when in demo experiment, therefore demoSamples is unused
// kept in case we every decide to use in future
export const demoSamples = [
    {
        id: '08a536d5-79dd-46e6-9df1-03b26b4adb9a',
        created_time: '2024-02-09T15:23:56.122Z',
        created_by: '0a4c347b-8e6a-40d1-940f-a76f32940dae',
        ex_id: 'f3feb0ac-082b-4f60-b89f-3c7f9ae006d6',
        ex_user: '0a4c347b-8e6a-40d1-940f-a76f32940dae',
        ex_time: '2024-02-09T15:23:56.122Z',
        ex: {
            analyzed_molecule: 'mRNA + IncRNA',
            experiment_id: '4015c7cc-1982-4bd4-ae1c-140a7aa6fba9',
            name: 'SampleName4',
            organism: 'Homo sapiens',
            other_categories: {
                Age: 45,
                Disease: 'dilated',
                Sex: 'male'
            },
            sequencing_instrument_model: 'Illumina MiniSeqDx',
            sequencing_instrument_platform: 'Illumina'
        },
        name: 'SampleName4',
        description: null,
        basename: null,
        sample_description: null,
        sample_number: null,
        sample_name: null,
        sex: null,
        source_tissue_name: null,
        source_organ_name: null,
        organism: 'Homo sapiens',
        condition: null,
        treatment_protocol: null,
        treatment_type: null,
        growth_protocol: null,
        analyzed_molecule: 'mRNA + IncRNA',
        extract_protocol: null,
        library_strategy: null,
        library_construction_protocol: null,
        sequencing_instrument_platform: 'Illumina',
        sequencing_instrument_model: 'Illumina MiniSeqDx',
        adapter_for_trimming: null,
        other_categories: {
            Age: 45,
            Disease: 'dilated',
            Sex: 'male'
        },
        number_of_files: null,
        status: null,
        archived: null,
        experiment_id: '4015c7cc-1982-4bd4-ae1c-140a7aa6fba9',
        sample_num: '3113',
        files: []
    },
    {
        id: '3b670348-5f72-4fb4-b75c-f0c04ccb3304',
        created_time: '2024-02-09T15:23:56.124Z',
        created_by: '0a4c347b-8e6a-40d1-940f-a76f32940dae',
        ex_id: 'cab6bbe5-6dd2-4c07-b23c-1954d8a34b03',
        ex_user: '0a4c347b-8e6a-40d1-940f-a76f32940dae',
        ex_time: '2024-02-09T15:23:56.124Z',
        ex: {
            analyzed_molecule: 'mRNA + IncRNA',
            experiment_id: '4015c7cc-1982-4bd4-ae1c-140a7aa6fba9',
            name: 'SampleName5',
            organism: 'Homo sapiens',
            other_categories: {
                Age: 46,
                Disease: 'control',
                Sex: 'female'
            },
            sequencing_instrument_model: 'Illumina MiniSeqDx',
            sequencing_instrument_platform: 'Illumina'
        },
        name: 'SampleName5',
        description: null,
        basename: null,
        sample_description: null,
        sample_number: null,
        sample_name: null,
        sex: null,
        source_tissue_name: null,
        source_organ_name: null,
        organism: 'Homo sapiens',
        condition: null,
        treatment_protocol: null,
        treatment_type: null,
        growth_protocol: null,
        analyzed_molecule: 'mRNA + IncRNA',
        extract_protocol: null,
        library_strategy: null,
        library_construction_protocol: null,
        sequencing_instrument_platform: 'Illumina',
        sequencing_instrument_model: 'Illumina MiniSeqDx',
        adapter_for_trimming: null,
        other_categories: {
            Age: 46,
            Disease: 'control',
            Sex: 'female'
        },
        number_of_files: null,
        status: null,
        archived: null,
        experiment_id: '4015c7cc-1982-4bd4-ae1c-140a7aa6fba9',
        sample_num: '3115',
        files: []
    },
    {
        id: 'c11678e0-6702-49fb-80c9-133441e3003d',
        created_time: '2024-02-09T15:23:56.126Z',
        created_by: '0a4c347b-8e6a-40d1-940f-a76f32940dae',
        ex_id: '93f0f502-4b4a-46ae-97ed-83d29268e542',
        ex_user: '0a4c347b-8e6a-40d1-940f-a76f32940dae',
        ex_time: '2024-02-09T15:23:56.126Z',
        ex: {
            analyzed_molecule: 'mRNA + IncRNA',
            experiment_id: '4015c7cc-1982-4bd4-ae1c-140a7aa6fba9',
            name: 'SampleName3',
            organism: 'Homo sapiens',
            other_categories: {
                Age: 44,
                Disease: 'control',
                Sex: 'female'
            },
            sequencing_instrument_model: 'Illumina MiniSeqDx',
            sequencing_instrument_platform: 'Illumina'
        },
        name: 'SampleName3',
        description: null,
        basename: null,
        sample_description: null,
        sample_number: null,
        sample_name: null,
        sex: null,
        source_tissue_name: null,
        source_organ_name: null,
        organism: 'Homo sapiens',
        condition: null,
        treatment_protocol: null,
        treatment_type: null,
        growth_protocol: null,
        analyzed_molecule: 'mRNA + IncRNA',
        extract_protocol: null,
        library_strategy: null,
        library_construction_protocol: null,
        sequencing_instrument_platform: 'Illumina',
        sequencing_instrument_model: 'Illumina MiniSeqDx',
        adapter_for_trimming: null,
        other_categories: {
            Age: 44,
            Disease: 'control',
            Sex: 'female'
        },
        number_of_files: null,
        status: null,
        archived: null,
        experiment_id: '4015c7cc-1982-4bd4-ae1c-140a7aa6fba9',
        sample_num: '3116',
        files: []
    },
    {
        id: '526d331e-ef81-46c2-b315-27d20c3530d5',
        created_time: '2024-02-09T15:23:56.123Z',
        created_by: '0a4c347b-8e6a-40d1-940f-a76f32940dae',
        ex_id: 'ff0290f4-9dbf-433c-a28c-008040d5967e',
        ex_user: '0a4c347b-8e6a-40d1-940f-a76f32940dae',
        ex_time: '2024-02-09T15:23:56.123Z',
        ex: {
            analyzed_molecule: 'mRNA + IncRNA',
            experiment_id: '4015c7cc-1982-4bd4-ae1c-140a7aa6fba9',
            name: 'SampleName2',
            organism: 'Homo sapiens',
            other_categories: {
                Age: 43,
                Disease: 'dilated',
                Sex: 'male'
            },
            sequencing_instrument_model: 'Illumina MiniSeqDx',
            sequencing_instrument_platform: 'Illumina'
        },
        name: 'SampleName2',
        description: null,
        basename: null,
        sample_description: null,
        sample_number: null,
        sample_name: null,
        sex: null,
        source_tissue_name: null,
        source_organ_name: null,
        organism: 'Homo sapiens',
        condition: null,
        treatment_protocol: null,
        treatment_type: null,
        growth_protocol: null,
        analyzed_molecule: 'mRNA + IncRNA',
        extract_protocol: null,
        library_strategy: null,
        library_construction_protocol: null,
        sequencing_instrument_platform: 'Illumina',
        sequencing_instrument_model: 'Illumina MiniSeqDx',
        adapter_for_trimming: null,
        other_categories: {
            Age: 43,
            Disease: 'dilated',
            Sex: 'male'
        },
        number_of_files: null,
        status: null,
        archived: null,
        experiment_id: '4015c7cc-1982-4bd4-ae1c-140a7aa6fba9',
        sample_num: '3117',
        files: []
    },
    {
        id: '7c4ae0e7-0aa3-4572-9b4a-715a92acadc0',
        created_time: '2024-02-09T15:23:56.122Z',
        created_by: '0a4c347b-8e6a-40d1-940f-a76f32940dae',
        ex_id: '6bb22fcc-4cb9-42e3-91b7-061b28e60843',
        ex_user: '0a4c347b-8e6a-40d1-940f-a76f32940dae',
        ex_time: '2024-02-09T15:23:56.122Z',
        ex: {
            analyzed_molecule: 'mRNA + IncRNA',
            experiment_id: '4015c7cc-1982-4bd4-ae1c-140a7aa6fba9',
            name: 'SampleName1',
            organism: 'Homo sapiens',
            other_categories: {
                Age: 42,
                Disease: 'control',
                Sex: 'female'
            },
            sequencing_instrument_model: 'Illumina MiniSeqDx',
            sequencing_instrument_platform: 'Illumina'
        },
        name: 'SampleName1',
        description: null,
        basename: null,
        sample_description: null,
        sample_number: null,
        sample_name: null,
        sex: null,
        source_tissue_name: null,
        source_organ_name: null,
        organism: 'Homo sapiens',
        condition: null,
        treatment_protocol: null,
        treatment_type: null,
        growth_protocol: null,
        analyzed_molecule: 'mRNA + IncRNA',
        extract_protocol: null,
        library_strategy: null,
        library_construction_protocol: null,
        sequencing_instrument_platform: 'Illumina',
        sequencing_instrument_model: 'Illumina MiniSeqDx',
        adapter_for_trimming: null,
        other_categories: {
            Age: 42,
            Disease: 'control',
            Sex: 'female'
        },
        number_of_files: null,
        status: null,
        archived: null,
        experiment_id: '4015c7cc-1982-4bd4-ae1c-140a7aa6fba9',
        sample_num: '3112',
        files: []
    },
    {
        id: 'd60223c1-bf82-4ddb-b202-9bad20e78a6d',
        created_time: '2024-02-09T15:23:56.125Z',
        created_by: '0a4c347b-8e6a-40d1-940f-a76f32940dae',
        ex_id: '2169165c-126b-4cb5-947a-4e8f0558e76f',
        ex_user: '0a4c347b-8e6a-40d1-940f-a76f32940dae',
        ex_time: '2024-02-09T15:23:56.125Z',
        ex: {
            analyzed_molecule: 'mRNA + IncRNA',
            experiment_id: '4015c7cc-1982-4bd4-ae1c-140a7aa6fba9',
            name: 'SampleName6',
            organism: 'Homo sapiens',
            other_categories: {
                Age: 47,
                Disease: 'dilated',
                Sex: 'male'
            },
            sequencing_instrument_model: 'Illumina MiniSeqDx',
            sequencing_instrument_platform: 'Illumina'
        },
        name: 'SampleName6',
        description: null,
        basename: null,
        sample_description: null,
        sample_number: null,
        sample_name: null,
        sex: null,
        source_tissue_name: null,
        source_organ_name: null,
        organism: 'Homo sapiens',
        condition: null,
        treatment_protocol: null,
        treatment_type: null,
        growth_protocol: null,
        analyzed_molecule: 'mRNA + IncRNA',
        extract_protocol: null,
        library_strategy: null,
        library_construction_protocol: null,
        sequencing_instrument_platform: 'Illumina',
        sequencing_instrument_model: 'Illumina MiniSeqDx',
        adapter_for_trimming: null,
        other_categories: {
            Age: 47,
            Disease: 'dilated',
            Sex: 'male'
        },
        number_of_files: null,
        status: null,
        archived: null,
        experiment_id: '4015c7cc-1982-4bd4-ae1c-140a7aa6fba9',
        sample_num: '3114',
        files: []
    }
];
